/**
 * Landing page icon components for consistent rendering across all platforms
 * Using Lucide React icons for clean, scalable SVG icons
 */

import { 
  Brain, 
  Zap, 
  CheckCircle, 
  TrendingUp, 
  Target, 
  Lock,
  Check
} from 'lucide-react';

export const LANDING_ICONS = {
  // Feature Icons
  BRAIN: Brain,           // Remember Forever
  LIGHTNING: Zap,         // Stop Wasting Time
  CHECKMARK: CheckCircle, // Honest Progress Tracking
  CHART: TrendingUp,      // Watch Your Growth
  TARGET: Target,         // Stay Focused
  LOCK: Lock,             // Your Data, Your Control
  
  // Brand Icons
  TICK: Check,            // AlgoTick logo mark
};

export default LANDING_ICONS;
